import React from 'react'
import {Box, Typography} from '@mui/material'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import ReactHtmlParser from 'react-html-parser'
import AppDialog from 'src/components-new/feedback/AppDialog'

const GREEN_MAIN = '#10b981'
const GREEN_DARK = '#059669'
const GREEN_TEXT = '#065f46'

const EMAIL_COLOR = '#007DA4'

interface ContactHelpDialogProps {
  open: boolean
  onClose: () => void
  greenNumber?: string
  greenNumberDescription?: string
  programEmail?: string
}

export default function ContactHelpDialog({open, onClose, greenNumber, greenNumberDescription, programEmail}: ContactHelpDialogProps) {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title='Hai bisogno di una mano?'
      maxWidth='xs'
    >
      <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, py: 0.5}}>
        {greenNumberDescription && (
          <Box
            sx={{
              fontSize: 14,
              color: 'text.secondary',
              lineHeight: 1.43,
              '& *': {fontFamily: 'inherit !important', backgroundColor: 'transparent !important'},
              '& p': {margin: 0},
            }}
          >
            {ReactHtmlParser(greenNumberDescription)}
          </Box>
        )}

        {greenNumber && (
          <Box
            sx={{
              background: 'linear-gradient(148deg, #ecfdf5 0%, #d1fae5 100%)',
              border: `1.5px solid ${GREEN_MAIN}`,
              borderRadius: 2,
              p: 3,
            }}
          >
            <Box sx={{display: 'flex', gap: 2, alignItems: 'flex-start'}}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: 1.5,
                  background: `linear-gradient(135deg, ${GREEN_MAIN} 0%, ${GREEN_DARK} 100%)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <LocalPhoneIcon sx={{color: '#fff', fontSize: 24}} />
              </Box>
              <Box sx={{flex: 1, minWidth: 0}}>
                <Typography sx={{fontSize: 14, fontWeight: 600, color: GREEN_TEXT, mb: 0.5}}>
                  Telefono
                </Typography>
                <Typography sx={{fontSize: 20, fontWeight: 700, color: GREEN_TEXT, lineHeight: 1.2, mb: 1.5}}>
                  {greenNumber}
                </Typography>
                <Box
                  component='a'
                  href={`tel:${greenNumber}`}
                  sx={{
                    display: 'inline-block',
                    backgroundColor: GREEN_MAIN,
                    color: '#fff',
                    fontSize: 13,
                    fontWeight: 500,
                    px: 1.5,
                    py: 0.75,
                    borderRadius: '6px',
                    textDecoration: 'none',
                    '&:hover': {backgroundColor: GREEN_DARK},
                  }}
                >
                  Chiama ora
                </Box>
              </Box>
            </Box>
          </Box>
        )}

        {programEmail && (
          <Box
            sx={{
              background: 'linear-gradient(151deg, #eff6ff 0%, #dbeafe 100%)',
              border: `1.5px solid ${EMAIL_COLOR}`,
              borderRadius: 2,
              p: 3,
            }}
          >
            <Box sx={{display: 'flex', gap: 2, alignItems: 'flex-start'}}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: 1.5,
                  backgroundColor: EMAIL_COLOR,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <EmailOutlinedIcon sx={{color: '#fff', fontSize: 24}} />
              </Box>
              <Box sx={{flex: 1, minWidth: 0}}>
                <Typography sx={{fontSize: 14, fontWeight: 600, color: EMAIL_COLOR, mb: 0.5}}>
                  Email
                </Typography>
                <Typography sx={{fontSize: 14, fontWeight: 600, color: EMAIL_COLOR, mb: 1.5, wordBreak: 'break-word'}}>
                  {programEmail}
                </Typography>
                <Box
                  component='a'
                  href={`mailto:${programEmail}`}
                  sx={{
                    display: 'inline-block',
                    backgroundColor: EMAIL_COLOR,
                    color: '#fff',
                    fontSize: 13,
                    fontWeight: 500,
                    px: 1.5,
                    py: 0.75,
                    borderRadius: '6px',
                    textDecoration: 'none',
                    '&:hover': {backgroundColor: EMAIL_COLOR},
                  }}
                >
                  Invia email
                </Box>
              </Box>
            </Box>
          </Box>
        )}

        <Box sx={{backgroundColor: '#fef3c7', borderRadius: 2, p: 2, textAlign: 'center'}}>
          <Typography sx={{fontSize: 12, color: 'text.secondary', lineHeight: 1.66}}>
            {'💡 Suggerimento: Per una risposta più rapida, contattaci telefonicamente durante l\'orario di ufficio'}
          </Typography>
        </Box>
      </Box>
    </AppDialog>
  )
}
